import { ISSFBehaviorsOptions } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { QUERY_customFieldsSettingsFetchCustomFields } from 'queries';
import { CustomFieldsSettingsFetchCustomFieldsQuery } from 'types/graphql';
import {
  CustomFieldTypeLabelMap,
  DATE_FORMAT,
} from 'pages/SettingsPage/CustomFieldsSettingsPage/CustomFieldsSettings.constants';
import { ICustomField } from 'pages/SettingsPage/CustomFieldsSettingsPage/CustomFieldsSettings.types';
import { DateTime } from 'luxon';

export function fetchCustomFieldsQueryConfig(): ISSFBehaviorsOptions {
  return {
    key: 'CUSTOMFIELDS_SETTINGS_PAGE_FETCH_CUSTOMFIELDS',
    query: QUERY_customFieldsSettingsFetchCustomFields,
    schema: {},
    responseTransformer: (data: CustomFieldsSettingsFetchCustomFieldsQuery): ICustomField[] =>
      data?.fetchCustomFields.nodes.map((customField) => ({
        id: customField.id,
        name: customField.name,
        mobile: customField.mobile,
        type: CustomFieldTypeLabelMap[customField.fieldType],
        allFacilities: customField.allFacilities,
        facilities: (customField.communities || []).map((community) => community.name),
        lastEdited: {
          date: DateTime.fromISO(customField.lastEditedAt).toFormat(DATE_FORMAT),
          by: 'TODO: pending lastEditedBy meta data',
        },
      })) || [],
  };
}
